<template>
    <div>

        <Flicking :options="options" @move-end="onMoveEnd">
            <div class="panel">
                <v-alert tile class="text-center minh" prominent color="#C51162" dark>
                    <div class="vc">
                        <img class="logo" src="../assets/partners/anthony_pixie.png" alt="anthony.pixie"></img>
                        <small><a class="text-white text-shadow" href="https://www.instagram.com/anthony.pixie/"
                                target="_blank">@anthony.pixie</a></small>
                        <br class="my-4">
                        <h3 class="mb-3 text-shadow">Ti interessano <b>PATCH</b> personalizzate?</h3>
                        <v-btn
                            @click="sendWA('Ciao,%20avrei%20bisogno%20di%20alcune%20informazioni%20per%20quanto%20riguarda%20le%20patch!')">
                            Richiedi info</v-btn>
                    </div>
                </v-alert>
            </div>
            <div class="panel">
                <v-alert tile class="text-center minh" prominent color="red" dark>
                    <div class="vc">
                        <v-icon x-large>mdi-tools</v-icon>
                        <h3 class="mb-1 text-shadow">Sei un riparatore o un preparatore di ASG?</h3>
                        <p class="text-shadow">Ti diamo l'opportunità di farti conoscere!</p>
                        <v-btn @click="sendWA('Ciao, sono un preparatore e vorrei farmi conoscere!')">
                            Contattaci</v-btn>
                    </div>
                </v-alert>
            </div>
        </Flicking>



    </div>
</template>

<script>

export default {
    name: "partner",
    props: {
        show: {
            type: Boolean,
            default: false
        }

    },
    data() {
        return {
            options: {
                circular: true,
                circularFallback: "bound",
                moveType: "snap",
                renderOnlyVisible: false
            }
        };
    },
    methods: {
        sendWA(mex) {
            window.location = 'https://wa.me/3475192722/?text=' + mex
        }
    }
}
</script>

<style scoped>
.text-white {
    color: white;
    text-decoration: none;
}

.logo {
    max-width: 200px;
}

.panel {
    width: 90%;
    margin: 10px;
}

.minh {
    min-height: 210px;
}

.vc {
    width: 95%;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}
</style>